import { Slide, Bounce, toast } from 'react-toastify'

export function SuccessAction({
  title = 'EXITO!',
  position = 'top-right',
  autoClose = 4000,
  transition = Slide,
}) {
  toast.success(title, {
    transition: transition,
    position: position,
    autoClose: autoClose,
    bodyClassName: 'react-toastify--success',
    className: 'react-toastify--success',
  })
  return {
    type: 'TOAST_SUCCESS',
    title,
  }
}

export function ErrorAction({
  title = '',
  position = 'top-right',
  autoClose = false,

  transition = Bounce,
}) {
  toast.error(title, {
    transition: transition,
    position: position,
    autoClose: autoClose,
    bodyClassName: 'react-toastify--error',
    className: 'react-toastify--error',
  })
  return {
    type: 'TOAST_ERROR',
    title,
  }
}

export function WarningAction({
  title = 'EXITO!',
  position = 'top-right',
  autoClose = 7000,
  transition = Bounce,
}) {
  toast.warn(title, {
    transition: transition,
    position: position,
    autoClose: autoClose,
    bodyClassName: 'react-toastify--warning',
    className: 'react-toastify--warning',
  })
  return {
    type: 'TOAST_WARNING',
    title,
  }
}

export function InfoAction({
  title = 'EXITO!',
  position = 'top-right',
  autoClose = 4000,
  transition = Slide,
}) {
  toast.info(title, {
    transition: transition,
    position: position,
    autoClose: autoClose,
    bodyClassName: 'react-toastify--info',
    className: 'react-toastify--info',
  })
  return {
    type: 'TOAST_INFO',
    title,
  }
}

export function DefaultAction({
  title = 'EXITO!',
  position = 'top-right',
  autoClose = 4000,
  transition = Slide,
}) {
  toast(title, {
    transition: transition,
    position: position,
    autoClose: autoClose,
  })
  return {
    type: 'TOAST_DEFAULT',
    title,
  }
}

export function reducer(state) {
  return state // doesn't need to do anything
}
